import React, { useState } from "react";
import Banner from "../../../Components/Common/Banner";
import GetInTouchUs from "../../../Components/Common/GetInTouchUs";
import contact_us_feedback from "../../../Assets/images/contact_us_feedback.png";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const FeedBack = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/feedback/send-feedback`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );
      const data = await response.json();
      if (response.ok) {
        toast.success(data?.message);
        setFormData({
          name: "",
          email: "",
          subject: "",
          message: "",
        });
        setIsLoading(false);
      } else {
        setIsLoading(false);
        toast.error(data?.error);
      }
    } catch (error) {
      console.error("Error submitting feedback:", error);
      alert("Failed to submit feedback. Please try again later.");
    }
  };

  return (
    <div>
      <ToastContainer />
      <Banner
        pageName="FEEDBACK"
        visible={false}
        breadcrummbs="Home / Contact Us / FeedBack"
        image={contact_us_feedback}
      />
      <div className="lg:px-20 md:px-10 px-5 py-10">
        <div className="">
          <h1 className="text-[#efae59] font-bold  text-[20px]">
            YOUR FEEDBACK IS OUR PRIORITY !
          </h1>
          <p className="tracking-wide text-justify mt-2 text-secondaryTextColor">
            Analytics and data gives us all sorts of insights into what our
            customers wants from our business. But it’s great to get an answer
            directly from our customers it will help us understand the “WHY”
            behind what people are doing. When we match customers feedback to
            what we are seeing in our analytics, we get a much clearer picture
            of what’s going on. Then we will know how to fix the problems and go
            after the right opportunities. So, we welcome feedback with open
            arms and request our customers to let us know if we could do better
            in any possible ways.
          </p>
          <p className="tracking-wide text-justify mt-4 text-secondaryTextColor">
            Let's jump in and get to it!
          </p>
          <p className="tracking-wide text-justify mt-4 text-secondaryTextColor">
            Here we have an easy way to send your feedback or even the tiniest
            issue which you would like to highlight. You can simply fill the
            form explain what exactly your concerns are and someone from our
            company will get back to you within 24 hours to look into it.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 grid-cols-1 mt-8 gap-10 mb-6">
          <form
            onSubmit={handleSubmit}
            action=""
            className="border md:p-8 p-4 rounded-lg"
          >
            <h1 className="text-[#7a96bd] font-medium md:text-xl border-b-2 border-[#7a96bd] inline-block">
              FEEDBACK FORM
            </h1>
            <div className="grid grid-cols-1 gap-2 mt-4">
              <input
                type="text"
                placeholder="Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="border border-gray-300 px-4 py-2"
              />
              <input
                type="email"
                placeholder="Email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="border border-gray-300 px-4 py-2"
              />
              <input
                type="text"
                placeholder="Subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                className="border border-gray-300 px-4 py-2"
              />
              <textarea
                type="text"
                placeholder="Feedback"
                name="message"
                value={formData.message}
                onChange={handleChange}
                className="border border-gray-300 px-4 py-2"
              />
            </div>
            <button
              disabled={isLoading}
              className="w-[200px] py-2 mt-4 text-white hover:bg-black cursor-pointer rounded-md flex items-center justify-center gap-2"
              style={{ backgroundColor: "#7A96BD" }}
            >
              {isLoading ? (
                <>
                  <div class="rounded-md h-5 w-5 border-2 border-white animate-spin"></div>
                  Loading..
                </>
              ) : (
                "Submit"
              )}
            </button>
          </form>
          <div>
            <img
              src="https://img.freepik.com/free-photo/collage-customer-experience-concept_23-2149367125.jpg?w=1800&t=st=1719225619~exp=1719226219~hmac=f6771dae51498ce19b1c2526827892446e28679f035c3e4ad4e0fe74241f9859"
              alt=""
              className="rounded-xl"
            />
          </div>
        </div>
        <GetInTouchUs />
      </div>
    </div>
  );
};

export default FeedBack;
